<template>
  <div class="item-unit-modal">
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.s_no') }}</label><span class="text-danger"> *</span>
                <div v-html="formData.s_no"></div>
            </div>
            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_facilities.facility_nature') }}</label><span class="text-danger"> * </span>
                <div v-html="formData.facility_nature"></div>
            </div>
             <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_facilities.type') }}</label><span class="text-danger"> * </span>
                <div v-html="formData.facility_type"></div>
            </div>

            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_facilities.existing_enhancement') }}</label><span class="text-danger"> * </span>
                <div v-html="formData.facility_origin"></div>
            </div>
              <div class="col-md-12">
                <label class="form-label">{{ $t('profile.financial_facilities.bank_name') }}</label><span class="text-danger"> *</span>
                <div v-html="formData.bank_name"></div>
            </div>

            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.collaterals') }}</label><span class="text-danger"> * </span>
                <div v-html="formData.collaterals"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.tenor') }}</label><span class="text-danger"> * </span>
                <div v-html="formData.tenor"></div>
            </div>
             <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.amount') }}</label><span class="text-danger"> * </span>
                <div v-html="$utils.formatMoney(amount, defaultCurrency)" />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.amount_overDue') }}</label>
                <div v-html="$utils.formatMoney(amount_overDue, defaultCurrency)" />
            </div>
        </div>
        
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeFinancialModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, maxLength, email, url, numeric,minValue,maxValue } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
        formData: {
            id:null,
            s_no: null,
            facility_origin:null,
            facility_nature:null,
            facility_type:null,
            amount:null,
            amount_overDue:null,
            tenor:null,
            collaterals:null,
            bank_name:null,
        },
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
     ...mapGetters('currency', [
      'defaultCurrency'
    ]),
    amount: {
      get: function () {
        return this.formData.amount / 100
      },
      set: function (newValue) {
        this.formData.amount = newValue * 100
      }
    },
    amount_overDue: {
      get: function () {
        return this.formData.amount_overDue / 100
      },
      set: function (newValue) {
        this.formData.amount_overDue = newValue * 100
      }
    },
  },
  created(){},
 validations: {},
  async mounted () {
    if (this.modalDataID) {
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    resetFormData () {
        this.formData = {
            id:null,
            s_no: null,
            facility_origin:null,
            facility_nature:null,
            facility_type:null,
            amount:null,
            amount_overDue:null,
            tenor:null,
            collaterals:null,
            bank_name:null,
        }
    },
    async setData () {
      this.formData = {
        id: this.modalData.id,
        s_no: this.modalData.s_no,
        facility_origin:this.modalData.facility_origin,
        facility_nature: this.modalData.facility_nature,
        facility_type:this.modalData.facility_type,
        amount:this.modalData.amount,
        amount_overDue:this.modalData.amount_overDue,
        tenor:this.modalData.tenor,
        collaterals:this.modalData.collaterals,
        bank_name:this.modalData.bank_name,
      }
    },
    closeFinancialModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
